// @ts-ignore
import ErrorIcon from '../style/icons/error.svg?raw'
// @ts-ignore
import SuccessIcon from '../style/icons/success.svg?raw'

export class FeedbackService {
    errorContainerId = "#newsletter_signup-error_message";
    successContainerId = "#newsletter_signup-success_message";
    emailContainerId = "#form-email";
    submitButtonId = "#newsletter-submit-button";
    unsubscribeButtonId = "#unsubscribe-button";

    public showErrorMessage = (message: string) => {
        const errorMessage: HTMLDivElement = document.querySelector(`${this.errorContainerId}`);
        const emailContainer: HTMLInputElement = document.querySelector(`${this.emailContainerId}`);
        if (!errorMessage || !emailContainer) { throw new Error("Error message div or email container not found"); }

        errorMessage.innerHTML = `${ErrorIcon} ${message}`;
        errorMessage.style.display = "flex";
        emailContainer.style.border = "1px solid #F55536";
    }

    public showSuccessMessage = (message: string) => {
        const successMessage: HTMLDivElement = document.querySelector(`${this.successContainerId}`);
        const emailContainer: HTMLInputElement = document.querySelector(`${this.emailContainerId}`);
        if (!successMessage || !emailContainer) { throw new Error("Success message div or email container not found"); }

        successMessage.innerHTML = `${SuccessIcon} ${message}`;
        successMessage.style.display = "flex";
        emailContainer.style.border = "1px solid #9FC507";
    }

    public hideMessages = () => {
        const errorMessage: HTMLDivElement = document.querySelector(`${this.errorContainerId}`);
        const successMessage: HTMLDivElement = document.querySelector(`${this.successContainerId}`);

        if (errorMessage) errorMessage.style.display = "none";
        if (successMessage) successMessage.style.display = "none";
    }


    public setButtonLoading = (buttonId: string, loading: boolean, spinnerColor: string): void => {
        const button = document.querySelector(buttonId) as HTMLButtonElement | HTMLAnchorElement;
        if (!button) return;

        if (loading) {
            const spinner = document.createElement('span');
            spinner.className = 'spinner';
            spinner.style.borderColor = spinnerColor;
            spinner.style.borderBottomColor = 'transparent';
            spinner.id = 'loading-spinner';
            
            button.setAttribute('disabled', 'true');
            button.style.pointerEvents = 'none';
            
            // Store original text
            const originalText = button.textContent || '';
            button.setAttribute('data-original-text', originalText);
            
            // Clear button and add spinner + text
            button.innerHTML = '';
            button.appendChild(spinner);
            button.appendChild(document.createTextNode(originalText));
        } else {
            button.removeAttribute('disabled');
            button.style.pointerEvents = 'auto';
            
            // Restore original text
            const originalText = button.getAttribute('data-original-text') || '';
            button.innerHTML = originalText;
            button.removeAttribute('data-original-text');
        }
    }

    public setSubmitButtonLoading = (loading: boolean): void => {
        this.setButtonLoading(this.submitButtonId, loading, "#ffffff");
    }

    public setUnsubscribeButtonLoading = (loading: boolean): void => {
        this.setButtonLoading(this.unsubscribeButtonId, loading, "#3442eb");
    }

    public reloadPage(): void {
        setTimeout(() => {
            location.reload();
        }, 1000);
    }
}

export const feedbackService = new FeedbackService();